
(function(){
  function showToast(message) {
  let toast = document.querySelector('.valse-cart-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'valse-cart-toast';
    toast.setAttribute('data-valse-cart-toast','');
    document.body.appendChild(toast);
  }
  toast.innerHTML = '<span>✓ ' + message + '</span><a class="valse-cart-toast__link" href="' + window.Shopify.routes.root + 'cart" aria-label="View cart">View cart</a>';
  toast.classList.add('is-visible');
  document.documentElement.classList.add('valse-cart-just-added');
  clearTimeout(window.valseCartToastTimer);
  window.valseCartToastTimer = setTimeout(function(){
    document.documentElement.classList.remove('valse-cart-just-added');
  }, 6500);
  // Keep the View cart notice visible after an item is added.
  // It sits above the live chat bubble so customers can reach cart without chat blocking it.
}
  function updateCartCount(){
    return fetch(window.Shopify.routes.root + 'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(cart){
      var badges=document.querySelectorAll('.valse-cart b,.cart-count-bubble,[data-cart-count],.cart-badge');
      badges.forEach(function(b){b.textContent=cart.item_count||0;b.classList.remove('valse-cart-count-bounce');void b.offsetWidth;b.classList.add('valse-cart-count-bounce')});
      return cart;
    })
  }
  function flyToCart(btn){
    var cartIcon=document.querySelector('.valse-cart')||document.querySelector('.cart-count-bubble')||document.querySelector('[data-cart-count]')||document.querySelector('.header__icon--cart');
    if(!cartIcon)return;
    var card=btn.closest('.product-card');var img=card&&card.querySelector('.product-card__image img');var start=(img||btn).getBoundingClientRect();var end=cartIcon.getBoundingClientRect();
    var dot;
    if(img&&img.currentSrc){dot=img.cloneNode(false);dot.removeAttribute('srcset');dot.src=img.currentSrc;dot.className='valse-fly-to-cart'}else{dot=document.createElement('div');dot.className='valse-fly-to-cart valse-fly-to-cart--dot'}
    dot.style.left=(start.left+start.width/2-29)+'px';dot.style.top=(start.top+start.height/2-29)+'px';document.body.appendChild(dot);
    requestAnimationFrame(function(){dot.style.transform='translate('+((end.left+end.width/2)-(start.left+start.width/2))+'px,'+((end.top+end.height/2)-(start.top+start.height/2))+'px) scale(.18)';dot.style.opacity='0'});
    setTimeout(function(){dot.remove()},800)
  }
  function setError(form,msg){var e=form&&form.querySelector('[data-card-error]');if(!e)return;e.hidden=!msg;e.textContent=msg||''}
  function smartAdd(variantId,qty){
    qty=Math.max(1,parseInt(qty||1,10)||1);
    return fetch(window.Shopify.routes.root + 'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(cart){
      var existing=(cart.items||[]).find(function(i){return String(i.variant_id)===String(variantId)});
      if(existing){return fetch(window.Shopify.routes.root + 'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:existing.key,quantity:existing.quantity+qty})})}
      return fetch(window.Shopify.routes.root + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:parseInt(variantId,10),quantity:qty})})
    }).then(function(r){if(!r.ok){return r.json().catch(function(){return{}}).then(function(d){throw new Error(d.description||d.message||'Could not add this item.')})}return updateCartCount()})
  }
  function handle(btn){
    if(!btn||btn.disabled)return;
    var form=btn.closest('form');var id=btn.dataset.variantId||(form&&form.querySelector('[name="id"]')&&form.querySelector('[name="id"]').value);var qty=(form&&form.querySelector('[name="quantity"]')&&form.querySelector('[name="quantity"]').value)||1;
    if(!id){setError(form,'Please choose an option before adding this item.');return}
    var text=btn.querySelector('.btn-text');var original=text?text.textContent:btn.textContent;setError(form,'');btn.disabled=true;btn.classList.add('is-adding');if(text)text.textContent='Adding...';else btn.textContent='Adding...';
    smartAdd(id,qty).then(function(){btn.classList.remove('is-adding');btn.classList.add('is-added');if(text)text.textContent='✓ Added';else btn.textContent='✓ Added';flyToCart(btn);showToast('Item added to cart!');setTimeout(function(){if(text)text.textContent=original;else btn.textContent=original;btn.classList.remove('is-added');btn.disabled=false},2000)}).catch(function(err){btn.classList.remove('is-adding','is-added');if(text)text.textContent='Try Again';else btn.textContent='Try Again';btn.style.background='#ff4444';btn.disabled=false;setError(form,err.message||'This item could not be added.');setTimeout(function(){if(text)text.textContent=original;else btn.textContent=original;btn.style.background='';},1800)})
  }
  document.addEventListener('click',function(e){var btn=e.target.closest('.btn-add-to-cart');if(!btn)return;e.preventDefault();e.stopImmediatePropagation();handle(btn)},true);

  document.addEventListener('click',function(e){
    var buy=e.target.closest('[data-buy-now-card]');
    if(!buy)return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if(buy.disabled)return;
    var variantId=buy.dataset.variantId;
    if(!variantId)return;
    var original=buy.textContent;
    buy.disabled=true;
    buy.textContent='Opening cart...';
    smartAdd(variantId,1).then(function(){window.location.href=window.Shopify.routes.root+'cart'}).catch(function(){buy.textContent='Try Again';buy.disabled=false;setTimeout(function(){buy.textContent=original},1600)});
  },true);

  document.addEventListener('submit',function(e){var form=e.target.closest('[data-product-card-form]');if(!form)return;e.preventDefault();e.stopImmediatePropagation();handle(form.querySelector('.btn-add-to-cart'))},true);
})();


/* Valse hotfix: keep collection buttons visible after theme/app CSS loads */
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.product-card__actions, .product-card__form, .product-card__button, .btn-add-to-cart, .btn-sold-out').forEach(function(el){
    el.style.visibility = 'visible';
    el.style.opacity = '1';
  });
});
